import React from "react";

function Hero() {
  return (
    <section className="container-fluid" id="supportHero">
      <div className="p-5" id="supportWrapper">
        <h4>Support Portal</h4>
        <a href="">Track Tickets</a>
      </div>
      <div className=" row p-5 m-3">
        <div className="col-6 p-3">
          <h1 className="fs-3">Search for an answer or browse help topics to create a ticket</h1>
          <input type="text" placeholder="Eg. how do I activate F&O " /><br />
          <a href="">Track account opening</a><br />
          <a href="">Track segment activation</a><br />
          <a href="">Intraday margins Kite user </a><br />
          <a href="">manual</a><br />
        </div>
        <div className="col-6 p-3 ">
            <h1>Featured</h1>
            <ol>
                <li>
                <a href="">Surveillance measure on scrips - February 2025 </a></li>
                <li><a href="">Latest Intraday leverages and Square-off timings</a></li>
            </ol>
          
        </div>

      </div>
    </section>
  );
}

export default Hero;
